"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeaderStyled = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _lodash = _interopRequireDefault(require("lodash.isfunction"));

var _oxygenConfig = require("@8x8/oxygen-config");

var ModalHeaderStyled = _interopRequireWildcard(require("./modal-header.styled"));

exports.ModalHeaderStyled = ModalHeaderStyled;

var _titleAlignment = _interopRequireDefault(require("./constants/title-alignment"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ModalHeader = function ModalHeader(_ref) {
  var alignTitle = _ref.alignTitle,
      children = _ref.children,
      title = _ref.title,
      onClose = _ref.onClose,
      theme = _ref.theme,
      passThroughProps = _objectWithoutProperties(_ref, ["alignTitle", "children", "title", "onClose", "theme"]);

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(ModalHeaderStyled.Container, _extends({
    onClose: onClose
  }, passThroughProps), title && /*#__PURE__*/_react["default"].createElement(ModalHeaderStyled.Title, {
    align: alignTitle
  }, title), (0, _lodash["default"])(onClose) && /*#__PURE__*/_react["default"].createElement(ModalHeaderStyled.CloseIcon, {
    link: true,
    onClick: onClose
  }), children));
};

ModalHeader.propTypes = {
  borderBottom: _propTypes["default"].bool,
  alignTitle: _propTypes["default"].oneOf(Object.values(_titleAlignment["default"])),
  title: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  testId: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node, _propTypes["default"].func]),
  theme: _propTypes["default"].object.isRequired
};
ModalHeader.defaultProps = {
  borderBottom: false,
  alignTitle: 'left',
  title: '',
  onClose: undefined,
  testId: 'MODAL_HEADER',
  children: null
};

var _default = (0, _oxygenConfig.withDeprecation)((0, _oxygenConfig.withTheme)(ModalHeader, 'modalHeader'), '@8x8/oxygen-modal-header is deprecated. Please use ModalHeader from @8x8/oxygen-modal package instead.');

exports["default"] = _default;